export const noValidToken = {
    error: true,
    response: {
        message: 'No valid token',
        status: 403,
    },
};
